var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGameActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"game\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.185 6.3468H7.815C5.16 6.3468 3 8.5068 3 11.1618V16.1838C3 18.8388 5.16 20.9988 7.815 20.9988H16.185C18.84 20.9988 21 18.8388 21 16.1838V11.1618C21 8.5068 18.84 6.3468 16.185 6.3468ZM14.25 12.0168C14.25 11.5218 14.655 11.1168 15.15 11.1168C15.645 11.1168 16.05 11.5218 16.05 12.0168C16.05 12.5118 15.645 12.9258 15.15 12.9258C14.655 12.9258 14.25 12.5298 14.25 12.0348V12.0168ZM10.317 15.6618C10.182 15.7968 10.011 15.8598 9.84 15.8598C9.669 15.8598 9.498 15.7968 9.363 15.6618L8.436 14.7348L7.545 15.6258C7.41 15.7608 7.239 15.8238 7.068 15.8238C6.897 15.8238 6.726 15.7608 6.591 15.6258C6.33 15.3648 6.33 14.9328 6.591 14.6718L7.482 13.7808L6.618 12.9168C6.357 12.6558 6.357 12.2238 6.618 11.9628C6.879 11.7018 7.311 11.7018 7.572 11.9628L8.436 12.8268L9.327 11.9358C9.588 11.6748 10.02 11.6748 10.281 11.9358C10.542 12.1968 10.542 12.6288 10.281 12.8898L9.39 13.7808L10.317 14.7078C10.578 14.9688 10.578 15.4008 10.317 15.6618ZM13.386 14.6988C12.891 14.6988 12.477 14.2938 12.477 13.7988C12.477 13.3038 12.873 12.8988 13.368 12.8988H13.386C13.881 12.8988 14.286 13.3038 14.286 13.7988C14.286 14.2938 13.89 14.6988 13.386 14.6988ZM15.15 16.4718C14.655 16.4718 14.25 16.0758 14.25 15.5808V15.5628C14.25 15.0678 14.655 14.6628 15.15 14.6628C15.645 14.6628 16.05 15.0678 16.05 15.5628C16.05 16.0578 15.654 16.4718 15.15 16.4718ZM16.932 14.6988C16.437 14.6988 16.023 14.2938 16.023 13.7988C16.023 13.3038 16.419 12.8988 16.914 12.8988H16.932C17.427 12.8988 17.832 13.3038 17.832 13.7988C17.832 14.2938 17.436 14.6988 16.932 14.6988Z",
    fill: "url(#paint0_linear_307_3620)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4754 3.639L13.4664 4.485C13.4574 5.277 12.8004 5.934 11.9994 5.934C11.8644 5.934 11.7834 6.024 11.7834 6.141C11.7834 6.258 11.8734 6.348 11.9904 6.348H10.5414C10.5324 6.285 10.5234 6.213 10.5234 6.141C10.5234 5.331 11.1804 4.674 11.9814 4.674C12.1164 4.674 12.2064 4.584 12.2064 4.467L12.2154 3.621C12.2244 3.279 12.5034 3 12.8454 3H12.8544C13.2054 3 13.4754 3.288 13.4754 3.639Z",
    fill: "url(#paint1_linear_307_3620)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_3620",
    x1: 3,
    y1: 13.779,
    x2: 21,
    y2: 13.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_3620",
    x1: 10.5234,
    y1: 4.69826,
    x2: 13.4754,
    y2: 4.69826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameActive);
export default __webpack_public_path__ + "static/media/icon_game_active.e617f2906b7ed26c82e22a1fb44688ae.svg";
export { ForwardRef as ReactComponent };